<template>
    <v-container fluid>
        <div v-if="!loading"> 

            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Brand awareness
            </v-row>
            <v-divider />
            <div v-if="awareness.length > 0">
                <!--table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col class="tabCell text-left">Trademark / Segment</v-col>
                    <v-col v-for="(segment, i) in segments" :key="i" class="tabCell text-center">
                        {{ segment.name }}
                    </v-col>
                </v-row>
                
                <!--awareness tab-->
                <v-row v-for="trademark in trademarks" :key="trademark.i" no-gutters>
                    <v-col class="tabCell text-left">{{ trademark.name }}</v-col>
                    <v-col v-for="(segment, i) in segments" :key="i" class="tabCell text-center">
                        {{ getAwareness(segment.id, trademark.id) }}
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You haven't awareness yet!
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import { roundNumber } from '../../../functions/common';
import Loader from '../../../layouts/Loader.vue';
export default {
    name: 'BrandAwareness',
    data() {
        return {}
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        awareness() {
            return this.$store.getters.awareness;
        },
        segments() {
            let res = [];
            if (this.awareness.length > 0) {
              this.awareness.map((item) => {
                const inArr = res.find((it) => it.id == item.segment.id)
                if (!inArr) {
                    res.push({ id: item.segment.id,
                        name: item.segment.name });
                }
                });  
            }
            return res;
        },
        trademarks() {
            let res = [];
            if (this.awareness.length > 0) {
              this.awareness.map((item) => {
                const inArr = res.find((it) => it.id == item.trademark.id)
                if (!inArr) {
                    res.push({ id: item.trademark.id,
                        name: item.trademark.name });
                }
                });  
            }
            return res;
        }
    },
    methods: {
        getAwareness(segmentId, trademarkId) {
            let line = this.awareness.find((item) => item.segmentId == segmentId && item.trademarkId == trademarkId);
            let res = line ? roundNumber(line.awareness, 2) : 0;
            return res;
        }
    },
    components: {Loader}
}
</script>